import React from 'react';
import i18n from '../../../i18n/i18n';

import LazyImage from '../../../components/LazyImage';

import digitalizedPlatformImg from "../../../images/bulkListing/digitalized-platform.png";
import findManageImg from "../../../images/bulkListing/find-manage.png";
import diversifiedMarketingImg from "../../../images/bulkListing/diversified-marketing.png";
import featureBuildingsImg from "../../../images/bulkListing/feature-buildings.png";
import accessOwnersImg from "../../../images/bulkListing/access-owners.png";
import bookingRateImg from "../../../images/bulkListing/booking-rate.png";
import snsViewsImg from "../../../images/bulkListing/sns-views.png";

const reasonsList = [
  {
    image: digitalizedPlatformImg,
    title: i18n.t("bulkListing.chooseUsBanner.digitalizedPlatform"),
    alt: "digitalized-platform-img"
  },
  {
    image: findManageImg,
    title: i18n.t("bulkListing.chooseUsBanner.findManage"),
    alt: "find-manage-img"
  },
  {
    image: diversifiedMarketingImg,
    title: i18n.t("bulkListing.chooseUsBanner.diversifiedMarketing"),
    alt: "diversify-marketing-img"
  },
  {
    image: featureBuildingsImg,
    title: i18n.t("bulkListing.chooseUsBanner.featureBuilding"),
    alt: "feature-buildings-img"
  },
  {
    image: accessOwnersImg,
    title: i18n.t("bulkListing.chooseUsBanner.accessOwners"),
    alt: "access-owners-img"
  },
  {
    image: bookingRateImg,
    title: i18n.t("bulkListing.chooseUsBanner.bookingRate"),
    alt: "booking-rate-img"
  },
  {
    image: snsViewsImg,
    title: i18n.t("bulkListing.chooseUsBanner.snsViews"),
    alt: "sns-views-img"
  },
];

const ChooseUsBanner = () => {
  return (
    <div className="w-full bg-[#F7F7F7] p-[25px] md:py-[50px] md:px-[70px] lg:py-[30px] lg:px-[100px] xl:px-[200px] 2xl:px-[300px]">
      <div className="flex flex-col items-center my-[15px]">
        <div className="text-[15px] text-black font-bold text-center md:text-[20px]">{i18n.t("bulkListing.chooseUsBanner.title")}</div>
        <div className="flex flex-row flex-wrap justify-center mt-[15px]">
          {reasonsList.map((reason, index) => (
            <div className="flex flex-col bg-white w-[220px] m-[10px] p-[20px] rounded-[8px] shadow-[1px_1px_5px_1px_rgba(0,0,0,0.2)]" key={`reason-${index}`}>
              <LazyImage className="w-[25%] object-cover" src={reason.image} alt={reason.alt} />
              <div className="flex">
                <div className="mt-[15px] text-black text-[11px] font-medium md:text-[12px]">{reason.title}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ChooseUsBanner;